import { createSelectorCreator, defaultMemoize } from 'reselect';
import isEqual from 'lodash.isequal';

// Global Selectors
import { makeSelectHarvestEventId } from 'services/harvestEvents/selectors';
import { selectContainerGroupsArray } from 'services/containerGroups/selectors';

const createDeepEqualSelector = createSelectorCreator(defaultMemoize, isEqual);

const selectIncompleteContainerGroup = createDeepEqualSelector(
    [selectContainerGroupsArray, makeSelectHarvestEventId()],
    (containerGroupsArrayState, eventIdState) => {
        const containerGroup = containerGroupsArrayState.find(
            value => value.eventId === eventIdState && !value.isComplete
        );
        return containerGroup;
    }
);

const makeSelectIncompleteContainerGroupValue = field =>
    createDeepEqualSelector(
        selectIncompleteContainerGroup,
        incompleteContainerGroupState =>
            incompleteContainerGroupState &&
            incompleteContainerGroupState[field]
    );

const makeSelectIncompleteContainerGroupId = () =>
    createDeepEqualSelector(
        selectIncompleteContainerGroup,
        incompleteContainerGroupState =>
            incompleteContainerGroupState && incompleteContainerGroupState.id
    );

export {
    selectIncompleteContainerGroup,
    makeSelectIncompleteContainerGroupValue,
    makeSelectIncompleteContainerGroupId
};
